export const gameDetailsListTextContent = {
  contactUsBtnText: "Contact Us",
  shareBtnText: "Share",
};
